// extracted by mini-css-extract-plugin
module.exports = {"list":"L2PillsList_list__Eo2Kv"};